import { useEffect, useState } from "react"

import { useCheckList } from "./CheckListContext"

import ButtonBar from "./ButtonBar"
import DeleteButton from "./DeleteButton"
import ReadOnlyField from "./ReadOnlyField"
import TextInput from "./TextInput"
import CheckBoxField from "./CheckBoxField" 

export default function SimpleCheckListItem({
    ctx, 
    hasAbbrLabel=true, 
    hasFeedback=true,
    hasGraded=true, 
    hasPromptID=false, 
    asTable=false
}) {
    const [rec, setRec] = useState(null)
    const { getRec } = useCheckList()

    useEffect(
        () => {
            !!ctx && setRec(getRec(ctx))
        }, [ctx, getRec]
    )

    if (!rec && asTable) {
        return (<tr><td colSpan="7">loading...</td></tr>)
    } else if (!rec) {
        return (<div>Loading...</div>)
    }

    if (asTable) {
        return (
            <tr>
                <td><ButtonBar rec={rec} /></td>
                <td>{rec.type}</td>
                <td><ReadOnlyField rec={rec} fld="id"  size="18" /></td>
                <td><TextInput rec={rec} fld="label" size="45" unique={true} /></td>
                <td>{hasAbbrLabel && <TextInput rec={rec} fld="abbrLabel" size="20"  />}</td>
                <td>{hasGraded && <CheckBoxField rec={rec} fld="graded"/> } </td>
                <td>{hasFeedback && <TextInput rec={rec} fld="feedback" size="20" />}</td>
                <td><DeleteButton rec={rec} /></td>
                <td></td>
            </tr>
        )
    }

    return (
        <div>
            <ButtonBar rec={rec} />
            <span>
                <b>{rec.type}</b>
                <ReadOnlyField rec={rec} fld="id" label="ID" size="30" />
                <TextInput rec={rec} fld="label" label="Label" size="50" unique={true} />
                {hasAbbrLabel && <TextInput rec={rec} fld="abbrLabel" size="30" label="Abbr. Label" />}
                {hasFeedback && <TextInput rec={rec} fld="feedback" size="30" label="Feedback" />}
                <DeleteButton rec={rec} />
            </span>
        </div>
    )
}

